/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfPageStore, newEqualCondition } from '@tw/tw-runtime';

import { SaleOrderRestApiService } from '@tw/clvip-api-gen';
import { SettingAddressChoiceLoadParam } from '../addressChoice/type';
import { SettingHistoryOrderStoreState } from './type';

export class SettingHistoryOrderStore extends BfPageStore<SettingHistoryOrderStoreState> {
  private saleOrderService: SaleOrderRestApiService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'setting/history-order'
        }
      }
    });

    this.saleOrderService = new SaleOrderRestApiService(this.appContext.getApiService());
  }

  async onLoad(param?: SettingAddressChoiceLoadParam) {
    this.setLoading(true);
    try {
      await this.fetchListData();
    } finally {
      this.setLoading(false);
    }
  }

  async fetchListData() {
    this.setLoading(true);
    const userInfo = this.appContext.getUserStore().getState().userInfo;
    const orders = await this.saleOrderService.query({
      noPaging: true,
      conditions: [newEqualCondition(SaleOrderRestApiService.ORDER_EMPLOYEE, userInfo.employee.id)]
    });

    console.log('orders', orders);

    this.setState({
      data: orders.rows
    });
    this.setLoading(false);
  }
}
